import React from "react";
import * as R from "ramda";

import { Row, Col } from 'antd';

import fbImg from '../assets/images/icon-footer-fb@3x.png';
import lineImg from '../assets/images/icon-footer-line@3x.png';
import igImg from '../assets/images/icon-footer-instagram@3x.png';
import ytImg from '../assets/images/icon-footer-youtube@3x.png';
import mailImg from '../assets/images/icon-footer-mail@3x.png';


export default function WebFooter() {

    return (
        <div>
            <div className="web-footer-padding-bottom">
                <Row type="flex" justify="center" gutter={[0, 0]} style={{ textAlign: "center" }}>
                    {footerContents.map((content, index) => (
                        <Col
                            xs={index === 2 ? 9 : index === 0 ? 8 : 6}
                            sm={R.or(index === 0, index === 2) ? 6 : 4}
                            key={index}
                        >
                            <div className="web-footer-text">
                                <a href={content.linkUrl}>{content.text}</a>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>

            <div className="web-footer-padding-bottom">
                <Row type="flex" justify="center" style={{ textAlign: "center" }}>
                    {footerIcons.map((footerIcon, index) => (
                        <Col span={3} key={index}>
                            <a href={footerIcon.linkUrl}>
                                <img src={footerIcon.icon} className="web-footer-img" alt="icon" />
                            </a>
                        </Col>
                    ))}
                </Row>
            </div>

            <Row type="flex" justify="center" style={{ textAlign: "center" }}>
                <Col span={24}>
                    <font className="web-footer-text-copyright">© Copyright 2019 FitGames Co.,Ltd All Rights Reserved.</font>
                </Col>
            </Row>
        </div>
    );
}


export const footerContents = [
    {
        text: "關於FitGames",
        linkUrl: "https://fitgames.web.app/helper/#about"
    },
    {
        text: "幫助中心",
        linkUrl: "https://fitgames.web.app/helper/"
    },
    {
        text: "隱私條款與政策",
        linkUrl: "https://fitgames.web.app/helper/#about-part-6"
    },
    {
        text: "成為隊長",
        linkUrl: "https://fitgames.web.app/helper/#contact"
    },
    {
        text: "聯絡我們",
        linkUrl: "https://fitgames.web.app/helper/#contact"
    },
]

const footerIcons = [
    {
        icon: fbImg,
        linkUrl: "https://www.facebook.com/fitgamestw/"
    },
    {
        icon: lineImg,
        linkUrl: "https://line.me/R/ti/p/%40227wuxqg"
    },
    {
        icon: igImg,
        linkUrl: "https://www.instagram.com/fitgames_/"
    },
    {
        icon: ytImg,
        linkUrl: "https://www.youtube.com/channel/UCUyCpiQOePzpqeL7XiCNhHA/featured"
    },
    {
        icon: mailImg,
        linkUrl: "mailto: support@fitgames.tw"
    },
]

